namespace $.$$ {

	export class $eve_app_page_components_button extends $.$eve_app_page_components_button {


	}

}

